// Copyright (c) Microsoft Corporation. All rights reserved.
// Licensed under the MIT License.
import { Util } from '@microsoft/applicationinsights-common';

var TelemetryTrace =
/** @class */
function () {
  function TelemetryTrace(id, parentId, name) {
    this.traceID = id || Util.newId();
    this.parentID = parentId;
    this.name = name;
  }

  return TelemetryTrace;
}();

export { TelemetryTrace };